(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/use-draw-data.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/use-draw-data.js');
"use strict";



const {
  useEffect
} = React;
const {
  getSpecificDrawName,
  productIds
} = svs.utils.products;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  ParticipantTypes
} = svs.components.sport.tipsenShared.constants;
const {
  userProduct2SubProductId
} = svs.components.sport.tipsenShared;
const {
  cache,
  helpers: {
    useAsyncSafeState
  }
} = svs.components.sport.quickplayModal;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const _getDrawItemCacheKey = _ref => {
  let {
    productId,
    drawNumber
  } = _ref;
  return "draw_".concat(productId, "_").concat(drawNumber);
};

function useDrawData(_ref2) {
  let {
    productId,
    drawNumber,
    onError
  } = _ref2;
  const [normalizedData, setNormalizedData] = useAsyncSafeState(null);
  useEffect(() => {
    const handleError = error => {
      logger.info("useDrawData() failed: \"".concat(error === null || error === void 0 ? void 0 : error.message, "\" (productId ").concat(productId, ")"));
      if (onError) {
        onError(error);
      }
    };
    _refreshDrawAsync({
      productId,
      drawNumber,
      setNormalizedData,
      handleError
    });
  }, [productId, drawNumber, onError, setNormalizedData]);
  return normalizedData;
}

async function _refreshDrawAsync(_ref3) {
  let {
    productId,
    drawNumber,
    setNormalizedData,
    handleError
  } = _ref3;
  try {
    if (!productId || productId === productIds.RACING || !drawNumber) {
      return;
    }
    const cacheKey = _getDrawItemCacheKey({
      productId,
      drawNumber
    });
    const cachedData = cache.getData({
      itemKey: cacheKey
    });
    if (cachedData) {
      setNormalizedData(cachedData);
      return;
    }
    const rawData = await _queryDrawAsync({
      productId,
      drawNumber
    });
    const normalizedData = _normalizeDraw(rawData);
    if (normalizedData) {
      cache.setData({
        itemKey: cacheKey,
        data: normalizedData
      });
      setNormalizedData(normalizedData);
    }
  } catch (error) {
    handleError(error);
  }
}

async function _queryDrawAsync(_ref4) {
  let {
    productId,
    drawNumber
  } = _ref4;
  const drawName = getSpecificDrawName(productId);
  if (!drawName) {
    throw new Error('Missing drawName');
  }
  const include = _getQueryInclude({
    productId
  });

  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'GET',
    path: "/draw/1/".concat(drawName, "/draws/").concat(drawNumber, "?include=").concat(include)
  });
  if (response.error || !response.draw) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Fetching of draw-data failed');
  }
  return response.draw;
}

function _getQueryInclude(_ref5) {
  let {
    productId
  } = _ref5;
  const isBomben = productId === productIds.BOMBEN;
  const eventsPropName = isBomben ? 'events' : 'drawEvents';
  const includedDrawFields = ['productId', 'drawNumber', 'regCloseTime', 'rowPrice', 'userProduct', 'productName'];
  const includedDrawEventsFields = ['eventNumber', 'eventDescription', 'eventComment', 'eventTypeId', 'participantType', 'outcomes.outcomeNumber', 'outcomes.description', 'match.participants.name', 'match.participants.mediumName'];
  const includedFields = [...includedDrawFields.map(field => "draw.".concat(field)), ...includedDrawEventsFields.map(field => "draw.".concat(eventsPropName, ".").concat(field))];
  return includedFields.join(',');
}

function _normalizeDraw(data) {
  const {
    productId,
    drawNumber,
    regCloseTime,
    drawEvents,
    events,
    rowPrice,
    userProduct,
    productName
  } = data || {};
  const subProductId = userProduct === productName ? undefined : userProduct2SubProductId[userProduct];
  if (productId && drawNumber) {
    const _events = drawEvents || events;
    if (!Array.isArray(_events) || _events.length === 0) {
      throw new Error('Missing "draw.drawEvents" in response from draw-API.');
    }
    if (_events.some((item, index) => item.eventNumber !== index + 1)) {
      logger.info('Warning: Unexpected use of "eventNumber" inside draw.drawEvents delivered by draw-API. This might lead to wrong behavior.');
    }
    return {
      productId,
      subProductId,
      rowPrice: rowPrice ? parseFloat(rowPrice.replace(',', '.')) : 1,
      drawNumber,
      regCloseTime,
      events: _events.map(event => _normalizeDrawEvent({
        event,
        productId
      }))
    };
  }
  throw new Error('Failed to normalize draw');
}

function _normalizeDrawEvent(_ref6) {
  let {
    event,
    productId
  } = _ref6;
  const {
    eventDescription,
    eventComment,
    eventTypeId,
    participantType,
    outcomes
  } = event;
  const {
    participants
  } = (event === null || event === void 0 ? void 0 : event.match) || {};
  const isPowerplayOrChallenge = [productIds.POWERPLAY, productIds.CHALLENGE].includes(productId);
  const hasParticipantsData = Array.isArray(participants) && participants.length === 2;
  const isPlayer = participantType === ParticipantTypes.Player;
  const hasOutcomes = Array.isArray(outcomes) && outcomes.every(item => item === null || item === void 0 ? void 0 : item.description);

  const result = {
    captionShort: hasParticipantsData ? participants.map(_ref7 => {
      let {
        mediumName
      } = _ref7;
      return mediumName;
    }).join(' - ') : eventDescription,
    captionLong: hasParticipantsData ? participants.map(_ref8 => {
      let {
        name
      } = _ref8;
      return name;
    }).join(' - ') : eventDescription
  };
  if (isPowerplayOrChallenge && hasParticipantsData) {
    if (isPlayer) {
      result.infoLine = eventComment || 'Vem gör flest mål?';
    } else if (eventComment && eventTypeId !== EventTypeId.EVENT_1X2) {
      result.infoLine = eventComment;
    }
  }
  if (hasOutcomes) {
    result.outcomesAsList = outcomes.map(_ref9 => {
      let {
        description
      } = _ref9;
      return [/[oöÖ]ver/i.test(description) && 'Ö', /under/i.test(description) && 'U', description].find(Boolean);
    });
    if (outcomes.length === 2 && outcomes[1].outcomeNumber === 4) {
      result.outcomesAsList.splice(1, 0, '');
    }
  }
  return result;
}
setGlobal('svs.components.sport.quickplayModal.hooks', {
  useDrawData
});

 })(window);